import { useState } from 'react';
import { Column, TwoColumnProps } from './types';

export const useTwoColumn = (props: TwoColumnProps) => {
  const {
    defaultActiveColumn = Column.L,
    dockTabsAtTop = true,
    showTabsOnMobile,
    showTabsOnTablet,
    ...otherProps
  } = props;
  const [activeColumn, setActiveColumn] = useState(defaultActiveColumn);

  const { content: leftColumnContent, isTwoColumn = false, ...leftColumn } = props.leftColumn;
  const { content: rightColumnContent, ...rightColumn } = props.rightColumn;
  const showTabs = showTabsOnTablet || showTabsOnMobile;

  return {
    ...otherProps,
    dockTabsAtTop,
    showLeftColumn: !leftColumn.hide,
    showRightColumn: !rightColumn.hide,
    isLeftColumnActive: !showTabs || activeColumn === Column.L,
    largeLeftColumn: isTwoColumn,
    leftColumnContent,
    rightColumnContent,
    showTabsOnMobile,
    showTabsOnTablet,
    tabProps: {
      activeTab: activeColumn === Column.L ? leftColumn.name : rightColumn.name,
      onChange: (tabName) => setActiveColumn(tabName === leftColumn.name ? Column.L : Column.R),
      tabs: [leftColumn, rightColumn],
    },
  };
};
